import { Component, DoCheck } from "@angular/core";
import { SharedService } from "../shared.service";
import { SanitizeHtmlPipe } from "../pipes/SanitizeHtml.pipe";
import { LoginCustomisation } from "../interfaces";

@Component({
  selector: "layout-footer",
  templateUrl: "./footer.component.html",
  providers: [SanitizeHtmlPipe],
})
export class FooterComponent implements DoCheck {
  private loginCustomisation: LoginCustomisation;
  public showFooter: boolean = false;
  public footerColor: string = "";
  public footerText: string = "";

  constructor(public sharedService: SharedService) {}

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        this.loginCustomisation = this.sharedService.loginCustomisation.value;
        if (this.loginCustomisation != null) {
          if (this.loginCustomisation.footerColor) {
            this.footerColor = this.loginCustomisation.footerColor;
          }
          if (this.loginCustomisation.footerTextId) {
            this.footerText = this.loginCustomisation.footerTextId;
          }
          this.showFooter = true;
        }
      }
    }
  }
}
